import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Icon from "../../shared_modules/common/icons/Icon";

const AGENT = "agent";

class MsgBannerReact extends PureComponent {
  static defaultProps = {
    applIntro: "See your payment plan options with ",
    provIntro: "See your payment plan options with ",
    errorIntro: "We are missing information",
    clientInfo: {},
    userInfo: {},
    errors: {},
  };

  renderMessage(clientName) {
    const { userInfo, applIntro, provIntro } = this.props,
      { userType } = userInfo,
      msgText = userType === AGENT ? provIntro : applIntro,
      { bizOwner, bizName } = clientName;

    return (
      <h1 id="pf-registration-pg-title" className="pg-title">
        <span id="msg-banner-intro" className="msg-banner-intro">
          {msgText}
        </span>
        <span id="msg-banner-provider" className="msg-banner-provider">
          {bizName}
        </span>
        {bizOwner && (
          <span
            id="msg-banner-provider-flname"
            className="msg-banner-provider-flname"
          >
            {bizOwner}
          </span>
        )}
        <Icon type="privsec" />
      </h1>
    );
  }

  generateClientName() {
    const { clientInfo } = this.props,
      {
        clientName,
        clientWebDisplay,
        clientDisplayName,
        clientFirstName,
        clientLastName,
      } = clientInfo,
      // clientName is roughly equivalent to
      // clientWebDisplay and clientDisplayName, each is not always
      // present in API response tho
      nameToDisplay = {
        bizName: clientWebDisplay || clientDisplayName || clientName,
      };
    let bizOwner;

    // if fname/lname exist, create bizOwner string
    if (clientFirstName && clientLastName) {
      bizOwner = `(${clientFirstName} ${clientLastName})`;
    }
    // if bizOwner exists, and ISN'T present in bizName, add it to obj
    if (bizOwner && nameToDisplay.bizName.indexOf(bizOwner) === -1) {
      nameToDisplay.bizOwner = bizOwner;
    }

    return nameToDisplay;
  }

  render() {
    const nameToDisplay = this.generateClientName();

    return (
      <div className="pf-registration-msg-banner">
        {nameToDisplay &&
          nameToDisplay.bizName &&
          this.renderMessage(nameToDisplay)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo,
    clientInfo: state.clientInfo,
  };
};

MsgBannerReact.propTypes = {
  errors: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  clientInfo: PropTypes.object.isRequired,
  applIntro: PropTypes.string.isRequired,
  provIntro: PropTypes.string.isRequired,
  errorIntro: PropTypes.string.isRequired,
};

const MsgBanner = connect(mapStateToProps)(MsgBannerReact);
export default MsgBanner;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');